<template>
  <div class="b-mint-creme m-0 text-center timesheets-main-container h-100">
    <div>
      <div class="timesheets-header-container">
        <div class="timesheets-header-box text-white">
          {{ headerText }}
        </div>
      </div>
    </div>
    <div class="timesheet-items-container">
      <v-card :loading="loading" :disabled="loading" class="h-100 background-none elevation-0">
        <template slot="progress">
          <v-progress-linear color="green" height="5" indeterminate></v-progress-linear>
        </template>
        <v-card-text class="pt-0">
          <v-row v-for="(commitment, index) in groupByCommitment" :key="index" class="mt-0 pa-0">
            <v-col md="12" sm="12" cols="12" class="timesheet-item ma-0 mt-5 pa-2">
              <v-row class="mt-0 pa-0"> 
                <v-col md="9" xs="7" cols="10">
                  <p>{{ commitment[0].Commitment.Name }}</p>
                </v-col>
                <v-col md="3" xs="5" cols="2">
                  <p class="text-right">{{ getCommimentHours(commitment) }}</p>
                </v-col>
              </v-row>
             
            </v-col>
            <v-col md="12" sm="12" cols="12" v-for="(item, index) in commitmentTimesheets(commitment[0].Commitment.id)" :key="index" class="pa-0 pt-2">
              <v-col md="12" @click="showTimesheet(item)" sm="12" cols="12" class="timesheet-item clickable ma-0" :style="backgroundColor(commitment[0].Commitment.id)">
                <p>
                  <b>{{ item.IssueNo }}</b>
                </p>
                <p class="truncate-three-line">
                  {{ item.Description }}
                </p>
                <p class="text-right m-0">
                  <b>{{ item.Effort }}H</b>
                </p>
                <p class="text-right m-0" v-if="item.Adjustment">
                  <b>{{ item.Adjustment > 0 ? `+` : `` }}{{ item.Adjustment }}H</b>
                </p>
              </v-col>
            </v-col>
          </v-row>
          
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>
<script lang="ts">
import Vue, { defineComponent } from "vue";
import LoadingComponent from "shared-components/src/components/Loading.vue";
import Timesheet from "../../models/Timesheet";
import TimesheetService from "../../services/TimesheetService";
import moment from "moment";

export default defineComponent({
  components: {
    LoadingComponent,
  },
  props: ["date", "teamMemberInfo", "commitmentColors"],
  data() {
    return {
      timesheets: [] as Timesheet[],
      groupByCommitment: [],
      loading: false,
    };
  },
  methods: {
    backgroundColor(commitmentId: any){
      var findCommitment = this.commitmentColors.find((c: any) => c.id == commitmentId);
      return `background-color: ${findCommitment.color}`;
    },
    commitmentTimesheets(commitmentId: any) {
      return this.timesheets.filter((c: any) => c.CommitmentId === commitmentId);
    },
    getCommimentHours(item:any) {
      var efforts = item.reduce((n:any, { Effort }:any) => n + Effort, 0);
      var adjustments = item.reduce((n:any, { Adjustment }:any) => n + Adjustment, 0);
      var sum = efforts + adjustments;
      return sum;
    },
    groupBy(key:any, array:any) {
      return array.reduce((objectsByKeyValue:any, obj:any) => {
        const value = obj[key];
        objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
        return objectsByKeyValue;
      }, {});
    },
    showTimesheet(item: any){
      this.$emit("editTimesheet", item);
    },
    async fetchTimesheets() {
      this.timesheets = [];
      this.loading = true;
      this.timesheets = await TimesheetService.getListInDateRange(this.teamMemberInfo.Id, new Date(this.date), new Date(this.date));
      this.groupByCommitment = this.groupBy("CommitmentId", this.timesheets);
      this.loading = false;
    },
  },
  computed: {
    headerText() {
      const dateStr = moment(this.date).format("ddd,DD MMMM YY");
      const tmName = this.teamMemberInfo ? this.teamMemberInfo.FullName : "";
      return `${tmName} [${dateStr}]`;
    },
  },
  watch: {
    async date(newVal: string) {
      await this.fetchTimesheets();
    },
  },
  mounted() {
    this.fetchTimesheets();
  },
});
</script>

<style lang="scss" scoped>
.timesheets-main-container {
  padding: 20px;
  .timesheets-header-container {
    border-bottom: 2px solid #000;
    text-align: center;
    .timesheets-header-box {
      background-color: #1e1e1e;
      padding: 15px;
      font-size: 18px;
      border-radius: 10px;
      margin: 0 auto 15px auto;
      width: fit-content;
    }
  }
  .timesheet-items-container {
    margin-top: 1px;
    height: 90%;
    overflow: auto;
    .v-card{
      overflow-y: scroll;
    }
    .timesheet-item {
      margin: 20px 0;
      border: 2px solid #000;
      border-radius: 10px;
      color: #000;
      text-align: left;
      padding: 15px;
      
    }

    p {
      margin-bottom: 5px;
    }
  }
}
@media screen and (min-width: 1190px) {
  .timesheets-main-container {
    max-height: 754px;
  }
}
</style>
